import { Anchor, AppShell, Group, Title } from "@mantine/core";
import { NavLink, Outlet } from "react-router";

export function App() {
  return (
    <AppShell header={{ height: 56 }} padding="md">
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Anchor component={NavLink} to="/" underline="never">
            <Title order={4}>CogQuest</Title>
          </Anchor>
          <Group gap="md">
            <Anchor
              component={NavLink}
              to="/how-it-works"
              style={({ isActive }: { isActive: boolean }) => ({
                fontWeight: isActive ? 600 : undefined,
                textDecoration: isActive ? "underline" : undefined,
              })}
            >
              how it works
            </Anchor>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
}
